import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import { useHistory } from 'react-router';
import { CloseIcon, MenuIcon, SearchGlassIcon } from '../../misc/icons/Icons';
import Breadcrumb from './partials/Breadcrumb';
import Menu from './partials/Menu';

const MobileNavigation = ({ activeTree, customTree }) => {
	const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
	const history = useHistory();

	return (
		<>
			<button
				type="button"
				onClick={() => setMobileMenuOpen(true)}
				className="flex flex-row w-full p-3 text-[1.0625rem] font-semibold text-left transition duration-150 ease-in-out text-oly-blue-dark can-hover:hover:bg-gray-50 focus:outline-none focus-visible:bg-gray-50"
				aria-labelledby="open-sidebar"
			>
				<MenuIcon className="w-6 h-6" />
			</button>
			<Transition.Root show={isMobileMenuOpen} as={Fragment}>
				<Dialog
					as="div"
					static
					className="fixed inset-0 z-40 flex lg:hidden"
					open={isMobileMenuOpen}
					onClose={setMobileMenuOpen}
				>
					<Transition.Child
						as={Fragment}
						enter="transition-opacity ease-linear duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="transition-opacity ease-linear duration-300"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75 cursor-pointer" />
					</Transition.Child>
					<Transition.Child
						as={Fragment}
						enter="transition ease-in-out duration-300 transform"
						enterFrom="-translate-x-full"
						enterTo="translate-x-0"
						leave="transition ease-in-out duration-300 transform"
						leaveFrom="translate-x-0"
						leaveTo="-translate-x-full"
					>
						<div className="relative flex flex-col flex-1 w-full pb-4 bg-oly-blue-default max-w-88 focus:outline-none">
							<Transition.Child
								as={Fragment}
								enter="ease-in-out duration-300"
								enterFrom="opacity-0"
								enterTo="opacity-100"
								leave="ease-in-out duration-300"
								leaveFrom="opacity-100"
								leaveTo="opacity-0"
							>
								<div className="absolute top-0 right-0 pt-1 -mr-12">
									<button
										type="button"
										onClick={() => setMobileMenuOpen(false)}
										className="flex items-center justify-center w-10 h-10 ml-1 focus:outline-none"
										aria-labelledby="close-sidebar"
									>
										<CloseIcon className="w-6 h-6 text-white" />
									</button>
								</div>
							</Transition.Child>
							<div className="px-4 py-2">
								<button
									type="button"
									onClick={() => history.push('/search')}
									className="flex items-center justify-end w-full text-white rounded-full h-9 bg-oly-blue-default-light can-hover:hover:bg-oly-blue-default-dark focus-visible:bg-oly-blue-default-dark focus:outline-none"
									aria-labelledby="open-search"
								>
									<SearchGlassIcon className="w-6 h-6 mr-3" />
								</button>
							</div>
							<Breadcrumb activeTree={activeTree} customTree={customTree} />
							<div className="flex-1 h-0 overflow-y-auto">
								<nav aria-label="Sidebar">
									<Menu activeTree={activeTree} />
								</nav>
							</div>
						</div>
					</Transition.Child>
					<div className="flex-shrink-0 w-14" aria-hidden="true">
						{/* Dummy element to force sidebar to shrink to fit close icon */}
					</div>
				</Dialog>
			</Transition.Root>
		</>
	);
};

export default MobileNavigation;
